import {moderationService} from "services/moderationService";
import {ChatMessageType, toDate, UserChatMessage} from "services";
import React, {FC, useContext, useState} from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {toDateString} from "utils";
import {Apps, GenderEvents, Genders} from "enums";
import {AuthContext} from "contexts";
import {Events, eventTracker} from "utils/eventTracker";

const getContent = (messageType: ChatMessageType, message: string) => {
    switch (messageType) {
        case ChatMessageType.Text:
            return message;
        case ChatMessageType.Audio:
            return "🔊Аудио";
        case ChatMessageType.Image:
            return "📷 Фото " + message;
        case ChatMessageType.SelfDestructingImage:
            return "📷 Самоудаляющееся Фото " + message;
        case ChatMessageType.ScamWarning:
            return null;
        case ChatMessageType.ScreenshotWarning:
            return "⚠️ Сделал скриншот";
        case ChatMessageType.Icebreaker:
            return `Ice-Breaker: ${message}`;
        case ChatMessageType.IcebreakerAnswer:
            return `Ice-Breaker Ответ: ${message}`;
        case ChatMessageType.Greeting:
            return `❤️‍🔥 Суперлайк ${message ? `: ${message}` : ''}`;
        default:
            return `${messageType.toString()}: ${message}`;
    }
}

interface Props {
    messages: UserChatMessage[]
    userKey: string
    userName: string;
    userGender: Genders;
}


export const ModerationChatAIAnalysis: FC<Props> = ({userName, userKey, userGender, messages}) => {
    const {env} = useContext(AuthContext);

    const [isAnalyzing, setIsAnalyzing] = useState(false);
    const [summaryData, setSummaryData] = useState("");

    const onModeration = async () => {
        if (isAnalyzing) {
            return
        }

        eventTracker.track(Events.ai_request, {
            type: 'chat',
            messagesCount: messages.length,
            userKey,
            gender: GenderEvents[userGender]
        })
        setIsAnalyzing(true)

        const texts = messages
            .filter(m => getContent(m.messageType, m.message))
            .map(m => {
                const date = toDate(m.date, env?.app ?? Apps.Instinct);
                const dateText = date ? ` (${toDateString(date, false)})` : '';
                return `${m.isMyMessage ? `${userName}` : "Другой"}${dateText}: ${getContent(m.messageType, m.message)}`
            });

        const text = texts.join('\n');

        const data = await moderationService.summarize(text)
        data && setSummaryData(data)

        setIsAnalyzing(false)
        eventTracker.track(Events.ai_response, {
            type: 'chat',
            messagesCount: messages.length,
            userKey,
            gender: GenderEvents[userGender],
            risk: data ? data?.indexOf("Высокий") > 0 ? "High" : data?.indexOf("Средний") ? 'Medium' : 'Low' : null,
            response: data
        })
    }

    return <div className="my-2">
        <div className="mb-1 d-flex flex-row justify-content-end">
            <button
                className="btn btn-outline-primary"
                onClick={onModeration}
                disabled={isAnalyzing}>
                {isAnalyzing ? 'Проводится анализ...' : 'Провести AI Анализ'}
            </button>
        </div>
        {summaryData &&
            <div
                className={`border p-3 rounded text-black`}>
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                        strong: ({node, ...props}) => <strong className="font-semibold" {...props} />,
                        li: ({node, ...props}) => <li className="mb-1" {...props} />,
                        p: ({node, ...props}) => <p className="mb-2" {...props} />,
                    }}
                >
                    {summaryData}
                </ReactMarkdown>
                {/*{moderationReport.flagged && (*/}
                {/*    <>*/}
                {/*        <strong>Нарушенные категории:</strong><br/>*/}
                {/*        {violatedCategories.length > 0 ? (*/}
                {/*            <ul className="mb-0 mt-2">*/}
                {/*                {violatedCategories.map(cat => (*/}
                {/*                    <li key={cat.name}>*/}
                {/*                        <strong>{cat.label}</strong> (оценка: {(cat.score * 100).toFixed(0)}%)*/}
                {/*                    </li>*/}
                {/*                ))}*/}
                {/*            </ul>*/}
                {/*        ) : (*/}
                {/*            <span>Категории не определены</span>*/}
                {/*        )}*/}
                {/*    </>*/}
                {/*)}*/}
            </div>
        }
    </div>
}